import React from "react"
import { Backdrop as BackdropMUI } from "@mui/material"
import PuffLoader from "react-spinners/PuffLoader"

const style = {
    color: "fff",
    zIndex: '1201!important'
}

const Backdrop = ({ open }) => {
    return (
        <BackdropMUI
            sx={style}
            open={open}
        >
            <PuffLoader
                color={'royalblue'}
                loading={open}
                className='puffloader'
                size={120}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </BackdropMUI>
    )
}

export default Backdrop